module.exports = __webpack_public_path__ + "img/sweetheart.29949c36.png";